const en = {
  "sale.sale.dispatch_today": "Who's in charge of dispatch today?",
  "sale.sale.dispatch_today_text":
    "  Step 1: Select a delivery service to start managing your orders.",
  "sale.sale.delivery.panel_text":
    "Manage the entire shipping process: ship, invoice, print, and liquidate",
  "sale.sale.delivery": "Delivery",
  "sale.sale.delivery_change": "Change Delivery",
  "sale.sale.delivery.panel_requirements":
    "Please review the requirements to continue.",
  "sale.sale.delivery_ok": "Ok",
  "sale.sale.delivery.panel_instructions":
    "Invoice and print each order. Then select them and confirm the dispatch.",
  "sale.sale.delivery.panel_liquidate_instructions":
    "Select the delivered and paid invoices to settle them.",
  "sale.sale.delivery.panel_orders_ready": "Orders Ready for Dispatch:",
  "sale.sale.delivery.panel_pending_documents": "Documents Pending Payment:",
  "sale.sale.delivery.panel.column.number": "Number",
  "sale.sale.delivery.panel.column.client": "Client",
  "sale.sale.delivery.panel.column.total": "Total",
  "sale.sale.delivery.panel.column.payment": "Payment",
  "sale.sale.delivery.panel.column.shipment_date": "Ship Date",
  "sale.sale.delivery.panel.column.delivery_time": "Delivery Time",
  "sale.sale.delivery.panel.column.state": "State",
  "sale.sale.delivery.panel.column.order_status": "Order",
  "sale.sale.delivery.panel.column.actions": "Actions",
  "sale.sale.delivery.panel.action.bill": "Invoice",
  "sale.sale.delivery.panel.action.print": "Print",
  "sale.sale.delivery.panel.no_address": "No address",
  "sale.sale.delivery.panel.status.commanded": "Commanded",
  "sale.sale.delivery.panel.status.dispatched": "Dispatched",
  "sale.sale.delivery.panel.status.draft": "Draft",
  "delivery.panel.delivery": "Delivery",
  "sale.sale.delivery.panel_progress": "Progress",
  "sale.sale.delivery.panel.modal.title": "Confirm Payment Reception",
  "sale.sale.delivery.panel.modal.subtitle":
    "Register payment for the selected invoices",
  "sale.sale.delivery.panel.modal.total_label": "Total Amount to Collect",
  "sale.sale.delivery.panel.modal.selected_invoices":
    "{count} Selected Invoices",
  "sale.sale.delivery.panel.modal.select_payment": "Select Payment Method",
  "sale.sale.delivery.panel.modal.confirm_button": "Confirm and Process",
  "sale.sale.delivery.panel.modal.processing_title": "Processing invoices...",
  "sale.sale.delivery.panel.modal.processing_message":
    "Please do not close the window",
  "sale.sale.delivery.panel.modal.partial_title": "Partial payment completed",
  "sale.sale.delivery.panel.modal.completed_message":
    "The money has been registered successfully.",
  "sale.sale.delivery.panel_ok": "Ok",
  "sale.sale.delivery.panel.selected": "Selected",
  "sale.sale.delivery.panel.total": "Total",
  "delivery.panel.by_dispached": "1. Dispached",
  "delivery.panel.dispached_liquidate": "2. Liquidate",
  "sale.sale.delivery.panel.column.delivery_amount": "Delivery",
  "delivery.panel.reports": "Reports",
  "sale_pos_frontend.detailed_deliveryman_report":
    "Detailed Deliveryman Report",
  "sale_pos_frontend.detailed_deliveryman.start.shop": "Store",
  "sale_pos_frontend.detailed_deliveryman.start.sale_date": "Date",
  "sale.sale.delivery.panel.modal.select_payment_required":
    "Select a payment method",
  "sale.sale.delivery.panel.modal.step1_subtitle": "Select the payment method",
  "sale.sale.delivery.panel.modal.step2_subtitle":
    "Review and confirm the amounts to collect",
  "sale.sale.delivery.panel.modal.loading": "Loading invoices...",
  "sale.sale.delivery.panel.modal.status_paid": "Fully paid",
  "sale.sale.delivery.panel.modal.status_abono": "Payment $ {amount}",
  "sale.sale.delivery.panel.modal.status_error": "Error processing",
  "sale.sale.delivery.panel.modal.pending": "Pending $ {amount}",
  "sale.sale.delivery.panel.modal.error_title": "Some payments had errors",
  "sale.sale.delivery.panel.modal.error_desc":
    "Invoices with errors were not processed. Check the details",
  "sale.sale.delivery.panel.modal.column.abonado": "Paid",
  "sale.sale.delivery.panel.modal.column.por_cobrar": "To collect",
  "sale.sale.delivery.panel.modal.column.payment_method": "Method",
  "sale.sale.delivery.panel.modal.column.a_pagar": "To pay now",
  "sale.sale.delivery.panel.modal.column.factura": "Invoice",
  "sale.sale.delivery.panel.modal.column.consumidor": "Consumer",
  "sale.sale.delivery.panel.modal.column.total": "Total",
  "sale.sale.delivery.panel.modal.continue": "Continue",
  "sale.sale.delivery.panel.modal.back": "Back",
  "sale.sale.delivery.panel.modal.close": "Close",
  "sale.sale.delivery.panel.modal.confirm_label": "Confirm",
  "sale.sale.delivery.panel.modal.completed_title":
    "Payment completed successfully",
  "sale.sale.delivery.panel.modal.processing_progress":
    "Processing {progress} of {total} invoices...",
  "sale.sale.delivery.panel.modal.total_to_collect": "Total to collect",
  "sale.sale.delivery.panel.modal.to_collect_now": "To collect now",
  "sale.sale.delivery.panel.modal.max_amount": "Max $ {amount}",
  "sale.sale.delivery.panel.modal.remaining": "Pending $ {amount}",
  "sale.sale.delivety.panel.modal.partial_paid":
    " Partial paid (distribute amount among invoices)",
  "sale.sale.delivery.panel.modal.column.voucher": "Voucher",
  "sale.sale.delivery.panel.column.paid_amount": "Paid",
  "sale.sale.delivery.panel.column.residual_amount": "Residual",
};

export default en;
